<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="content">
                    <status-order
                        :orderResult="orderResult"></status-order>
                    <b-button size="sm" class="m-1" @click="odExpand = !odExpand" variant="link">
                        Order {{odExpand ? "Hide" : "Show"}}
                    </b-button>
                    <b-collapse v-model="odExpand">
                        <order-details :orderResult="orderResult"></order-details>
                    </b-collapse>                                        
                </div>    
            </div>           
        </div>
    </div>
</template>
<script>

import StatusOrder from '@/components/menu/StatusOrder'
import OrderDetails from '@/components/menu/OrderDetails'

export default {
    name:'ShortOrderStatus',
     components: {
        StatusOrder,
        OrderDetails
    },
    data(){
        return { orderResult:{ _id : this.$route.params.orderId }, odExpand : true }
    },
    watch: {
        '$route.params.orderId': function () {
            this.orderResult = {_id: this.$route.params.orderId}           
        }
    }
}
</script>
